import { CustomFieldGroupType, CustomFieldType } from './CustomFieldTypes';

export const validateCustomFieldEditor = ({
    groups,
    fields,
    supportsGroups,
    t,
}: {
    groups: CustomFieldGroupType[];
    fields: CustomFieldType[];
    supportsGroups: boolean;
    t: (key: string, options?: any) => string;
}) => {
    const errors: string[] = [];

    // Set the fields that required options
    const fieldTypesThatRequireOptions: CustomFieldType['field_type'][] = [
        'dropdown',
        'checkbox',
        'tabs',
    ];

    // Create error if group title is not set
    if (supportsGroups) {
        groups
            .filter(custom_field_group => !custom_field_group.deleted)
            .forEach((custom_field_group, index) => {
                if (!custom_field_group.title?.trim()) {
                    errors.push(
                        t('custom_field.validation.group_title_required', {
                            number: index + 1,
                        })
                    );
                }
            });
    }

    // Create error if field label and options are not set
    fields
        .filter(custom_field => !custom_field.deleted)
        .forEach((custom_field, index) => {
            const label = custom_field.label?.trim();

            if (!label) {
                errors.push(
                    t('custom_field.validation.field_label_required', {
                        number: index + 1,
                    })
                );
            }

            if (fieldTypesThatRequireOptions.includes(custom_field.field_type)) {
                const activeOptions = (custom_field.options || []).filter(custom_field_option => {
                    return !custom_field_option.deleted && custom_field_option.label?.trim();
                });

                if (activeOptions.length === 0) {
                    errors.push(
                        t('custom_field.validation.field_options_required', {
                            label: label || t('custom_field.general.new_field_label'),
                        })
                    );
                }
            }
        });

    return errors;
};